// @ts-check

window.addEventListener("load", async () => {
  try {
    const options = document.querySelectorAll(
      ".variant-options .variant-option"
    );

    const categories = document.querySelectorAll(".variants-category");

    const variantsToCheck = [
      ...new Set(
        Array.from(options).map((option) =>
          // @ts-ignore
          Number(option.dataset.variantId)
        )
      ),
    ];

    const QUERY = `#graphql
    query ProductVariants($ids: [ID!]!) {
      nodes(ids: $ids) {
        id
        ... on ProductVariant {
          quantityAvailable
          product {
            onlineStoreUrl
            featuredImage {
              url
            }
          }
          price {
            amount
          }
          compareAtPrice {
            amount
          }
        }
      }
    }`;

    const res = await fetch(
      "https://mediamarkt-canarias.myshopify.com/api/2024-07/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // @ts-ignore
          "X-Shopify-Storefront-Access-Token": window.mmkt.config.shopifyApiKey,
        },
        body: JSON.stringify({
          query: QUERY,
          variables: {
            ids: variantsToCheck.map(
              (id) => `gid://shopify/ProductVariant/${id}`
            ),
          },
        }),
      }
    );

    const {
      data: { nodes },
    } = await res.json();

    const formatter = new Intl.NumberFormat(`es-ES`, {
      style: "currency",
      currency: "EUR",
    });

    categories.forEach((category) => {
      const title = category.querySelector(".variant-category-title");
      const opts = category.querySelectorAll(
        ".variant-options .variant-option"
      );
      const imgsToDel = category.querySelectorAll("img.skeleton");

      imgsToDel.forEach((img) => img.remove());

      title?.classList.remove("hidden");

      opts.forEach((option) => {
        const info = nodes.find((node) =>
          // @ts-ignore
          node && node.id && node.id.includes(option.dataset.variantId)
        );

        if (!info || !info.quantityAvailable) {
          option.remove();

          return;
        }

        const priceEl = option.querySelector(".variant-price");
        const imageEl = option.querySelector("img");

        // @ts-ignore
        priceEl.innerHTML = formatter.format(info.price.amount);

        if (imageEl) {
          imageEl.src = info.product.featuredImage.url;
          imageEl.srcset = info.product.featuredImage.url;
          imageEl.alt = info.product.featuredImage.altText;
        }

        option.classList.remove("hidden");

        if (!option.classList.contains("selected")) {
          option.addEventListener("click", () => {
            window.location.href = info.product.onlineStoreUrl;
          });
        }
      });

      const restOpts = category.querySelectorAll(
        ".variant-options .variant-option"
      );

      if (
        !restOpts.length ||
        (restOpts.length === 1 && restOpts[0].classList.contains("selected"))
      ) {
        category.remove();
      }
    });
  } catch (error) {
    console.log(error);
  }
});
